/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_CadenceInputs */

const en_svtag_cadence = /** @type {(inputs: Svtag_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CADENCE`)
};

const ar_svtag_cadence = /** @type {(inputs: Svtag_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#إيقاع`)
};

const bn_svtag_cadence = /** @type {(inputs: Svtag_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CADENCE`)
};

const de_svtag_cadence = /** @type {(inputs: Svtag_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CADENCE`)
};

const es_svtag_cadence = /** @type {(inputs: Svtag_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CADENCE`)
};

const fr_svtag_cadence = /** @type {(inputs: Svtag_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CADENCE`)
};

const pt_svtag_cadence = /** @type {(inputs: Svtag_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CADENCE`)
};

const zh_svtag_cadence = /** @type {(inputs: Svtag_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CADENCE`)
};

const tr_svtag_cadence = /** @type {(inputs: Svtag_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CADENCE`)
};

const ru_svtag_cadence = /** @type {(inputs: Svtag_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CADENCE`)
};

const pl_svtag_cadence = /** @type {(inputs: Svtag_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CADENCE`)
};

/**
* | output |
* | --- |
* | "#CADENCE" |
*
* @param {Svtag_CadenceInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_cadence = /** @type {((inputs?: Svtag_CadenceInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_CadenceInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_cadence(inputs)
	if (locale === "bn") return bn_svtag_cadence(inputs)
	if (locale === "de") return de_svtag_cadence(inputs)
	if (locale === "es") return es_svtag_cadence(inputs)
	if (locale === "fr") return fr_svtag_cadence(inputs)
	if (locale === "pt") return pt_svtag_cadence(inputs)
	if (locale === "zh") return zh_svtag_cadence(inputs)
	if (locale === "tr") return tr_svtag_cadence(inputs)
	if (locale === "ru") return ru_svtag_cadence(inputs)
	if (locale === "pl") return pl_svtag_cadence(inputs)
	return en_svtag_cadence(inputs)
});